export const weatherSerializer = (currentWeatherData, forcastWeatherData) => {
    function splitTemperature(temp){
        const temperature = temp.split('.');
        return temperature[0];
    }
    
    console.log('currentWeatherData ', currentWeatherData);
    console.log('forcastWeatherData ', forcastWeatherData);
    return {
        city: currentWeatherData[0]?.City ?? 'No results',
        temperature: currentWeatherData[0]?.Temperature ? splitTemperature(currentWeatherData[0]?.Temperature) : '0',
        currentTemperatureIcon: currentWeatherData[0]?.Icon ? currentWeatherData[0]?.Icon.split('.')?.[0] : null,
        firstHour: forcastWeatherData[0]?.Temperature ? splitTemperature(forcastWeatherData[0]?.Temperature) : '0',
        firstHourIcon: forcastWeatherData[0]?.Icon ? forcastWeatherData[0]?.Icon.split('.')?.[0] : null,
        secondHour: forcastWeatherData[1]?.Temperature ? splitTemperature(forcastWeatherData[1]?.Temperature) : '0',
        secondHourIcon: forcastWeatherData[1]?.Icon ? forcastWeatherData[1]?.Icon.split('.')?.[0] : null,
        thirdHour: forcastWeatherData[2]?.Temperature ? splitTemperature(forcastWeatherData[2]?.Temperature) : '0',
        thirdHourIcon: forcastWeatherData[2]?.Icon ? forcastWeatherData[2]?.Icon.split('.')?.[0] : null
    };
};